import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: Poppins, system-ui, -apple-system, 'Segoe UI', Roboto,
      'Helvetica Neue', Arial, 'Noto Sans', 'Liberation Sans', sans-serif;
  }


  /* Works on Firefox */
  * {
    scrollbar-width: 0.5vw;
    scrollbar-color: #386EAD40;

  }
  
  /* Works on Chrome, Edge, and Safari */
  *::-webkit-scrollbar {
    width: 10px;
  }
  
  *::-webkit-scrollbar-track:overflow-x {
    background: transparent;
  }

  *::-webkit-scrollbar:horizontal {
    display: none;
  }

  *::-webkit-scrollbar-thumb {
    background-color: #CCCBCC;
    border: none;
    border-radius: 8px;
  }


  body {
      background-color: ${({ theme }) => theme.colors.background.white};
      width: 100vw;
      height: 100%;
    }

    button {
      cursor: pointer;
    }





    .entryMessageModalContainer {
      top: 96px;
      z-index: 2000;
    
      display: flex;
      flex-direction: column;
      align-items: center;
      margin: 0 auto 36px auto;
    
      min-width: 400px;
      max-width: 416px;
      width: fit-content;
    
      height: fit-content;
      max-height: 76vh !important;
    
      overflow-y: auto;
      border-radius: 12px;
      border: none;
      outline: none;
    
      position: relative;
      padding: 16px 16px 0 16px;
      background-color: white;
    
      box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.14), 0px 2px 1px rgba(0, 0, 0, 0.12),
        0px 1px 3px rgba(0, 0, 0, 0.2);
    
      /* Works on Firefox */
    
      scrollbar-width: 0.5vw;
      scrollbar-color: #386ead40;
    
      /* Works on Chrome, Edge, and Safari */
      &::-webkit-scrollbar {
        width: 6px;
      }
    
      &::-webkit-scrollbar-track:overflow-x {
        background: transparent;
      }
    
      &::-webkit-scrollbar:horizontal {
        display: none;
      }
    
      &::-webkit-scrollbar-thumb {
        background-color: #cccbcc;
        border: none;
        border-radius: 4px;
      }
    }
    
    .entryMessageModal {
      max-width: 100% !important;
      width: 100% !important;
    
      a {
        color: #005fae;
        text-decoration: underline;
      }
    
      >div {
        max-width: 488px;
      }
    
      p {
        display: flex;
        justify-content: center;
        width: 100%;
        margin: 0;
    
        img {
          width: 100% !important;
          object-fit: cover;
          padding: 0 !important;
        }
      }
    
      p {
        width: fit-content;
      }
    }
    
    .entryMessageModalButton {
      display: flex;
      justify-content: center;
      width: 100%;
      position: sticky;
      bottom: 0;
      background: linear-gradient(180deg,
          rgba(255, 255, 255, 0.2) 0%,
          rgba(255, 255, 255, 1) 16%);
      box-shadow: -1px 0px 12px 15px rgba(255, 255, 255, 0.2);
      padding: 12px;
    
      button {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 10px;
        background: #f58220;
        border: 0;
        padding: 14px 20px;
        max-width: 180px;
        border-radius: 12px;
        color: #fff;
        transition: background-color 0.2s;
        cursor: pointer;
    
        svg {
          transition: color 0.2s;
          background-color: #fff;
          color: #f58220;
          border-radius: 50%;
        }
    
        &:hover {
          background: #005fae;
    
          svg {
            color: #005fae;
          }
        }
      }
    }
    
    .exitMessageModalContainer {
      top: 24%;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      align-items: center;
      max-width: 416px;
      width: fit-content;
      height: fit-content;
      max-height: 644px;
      overflow-y: auto;
      border-radius: 12px;
      border: none;
      outline: none;
      position: relative;
      padding: 16px;
      background-color: white;
    
      box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.14), 0px 2px 1px rgba(0, 0, 0, 0.12),
        0px 1px 3px rgba(0, 0, 0, 0.2);
    
      /* Works on Firefox */
    
      scrollbar-width: 0.5vw;
      scrollbar-color: #386ead40;
    
      /* Works on Chrome, Edge, and Safari */
      &::-webkit-scrollbar {
        width: 6px;
      }
    
      &::-webkit-scrollbar-track:overflow-x {
        background: transparent;
      }
    
      &::-webkit-scrollbar:horizontal {
        display: none;
      }
    
      &::-webkit-scrollbar-thumb {
        background-color: #cccbcc;
        border: none;
        border-radius: 4px;
      }
    }
    
    .exitMessageModal {
      a {
        color: #005fae;
        text-decoration: underline;
      }
    
      >div {
        max-width: 488px;
      }
    
      p {
        width: fit-content;
      }
    }
    
    .exitMessageModalButton {
      margin-top: 32px;
      display: flex;
      width: 100%;
      align-items: center;
      justify-content: center;
    
      button {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 10px;
        background: #f58220 !important;
        border: 1px solid red;
        padding: 14px 20px;
        max-width: 180px;
        border-radius: 12px;
        color: #fff;
        transition: background-color 0.2s;
        cursor: pointer;
    
        svg {
          transition: color 0.2s;
          background-color: #fff;
          color: #f58220;
          border-radius: 50%;
        }
    
        &:hover {
          background: #005fae;
    
          svg {
            color: #005fae;
          }
        }
      }
    }

    .modal {
      display: none !important;
      height: 100vh;
      width: 100vw;
      position: absolute;
      z-index: 10;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: rgba(0, 0, 0, 0.65);
    
      p,
      h2 {
        margin: 0;
      }
    }
    
    .modalOpen {
      display: flex !important;
    }
    
    .modalContent {
      background: #fff;
      box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.14), 0px 2px 1px rgba(0, 0, 0, 0.12),
        0px 1px 3px rgba(0, 0, 0, 0.2);
      border-radius: 12px;
      padding: 32px 16px;
      max-width: 480px;
      max-height: 460px;
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 16px;
      overflow-y: auto;
    }
    
    .modalConfirmedPix {
      top: 24%;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      align-items: center;
      max-width: 480px;
      width: fit-content;
      height: fit-content;
      max-height: 644px;
      overflow-y: auto;
      border-radius: 12px;
      border: none;
      outline: none;
      position: relative;
      padding: 16px;
      background-color: white;
    
      box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.14), 0px 2px 1px rgba(0, 0, 0, 0.12),
        0px 1px 3px rgba(0, 0, 0, 0.2);
    
      .iconWarning {
        color: #f58220;
        margin: 0 auto;
      }
    
      /* Works on Firefox */
    
      scrollbar-width: 0.5vw;
      scrollbar-color: #386ead40;
    
      /* Works on Chrome, Edge, and Safari */
      &::-webkit-scrollbar {
        width: 6px;
      }
    
      &::-webkit-scrollbar-track:overflow-x {
        background: transparent;
      }
    
      &::-webkit-scrollbar:horizontal {
        display: none;
      }
    
      &::-webkit-scrollbar-thumb {
        background-color: #cccbcc;
        border: none;
        border-radius: 4px;
      }
    }
    
    .iconModalPixSuccessMessage {
      width: 100%;
      display: flex;
      justify-content: center;
    }
    
    .modalDetail {
      display: flex;
      flex-direction: column;
      gap: 16px;
      width: 100%;
    }
    
    .modalPixSuccessMessage {
      h2 {
        font-size: 16px;
        color: #807e80;
        text-align: center;
        font-weight: 500;
      }
    }
    
    .modalButton {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      margin-top: 8px;
    
      button {
        cursor: pointer;
        display: flex;
        align-items: center;
        gap: 10px;
        border: none;
        background-color: #f58220;
        color: #fff;
        padding: 14px 20px;
        border-radius: 12px;
        transition: filter 0.2s;
    
        svg {
          color: #f58220;
          background-color: #fff;
          border-radius: 50%;
        }
    
        &:hover {
          filter: brightness(0.8);
        }
      }
    }
`;
